import React, {Component} from 'react';     
import PropTypes from 'prop-types';
import {Pagination, Row, Col} from 'react-bootstrap';
import {AdvisoryHeaderDiv, AdvisoryHeaderText} from '../../theme/MorsTheme';
import renderHTML from 'react-render-html';



//var dateFormat = require('dateformat');

const propTypes = {
    items: PropTypes.array.isRequired,   
    onChangePage: PropTypes.func.isRequired,
    initialPage: PropTypes.number,
    pageSize: PropTypes.number
}

const defaultProps = {
    initialPage: 1,    
    pageSize: 1
}

class Home extends Component{
    constructor(props) {
        super(props); 
        this.state = {
            pager: {},
            pageOfItems: [],                          
        };         
        
        this.onChangePage = this.onChangePage.bind(this);            
    }

    
    componentWillMount(){                    
    if(this.props.items && this.props.items.length){        
            this.setPage(this.props.initialPage);
        }
    }   

    componentDidUpdate(prevProps, prevState){                
       // if(this.props.items !== prevProps.items){                
         //   this.setPage(this.props.initialPage);
        //}
    }
    
    //Monina start - added
    compareMultiples(objs){
        return function(a, b) {
        var comparison = 0;
        objs.forEach(function(arg, i){
            var tempResult = a[arg.field].localeCompare(b[arg.field]);
            comparison = comparison || ((arg.order == 'desc') ? (tempResult * -1) : tempResult);
        });
        
        return comparison;
        }
    }
    //Monina end - added

    setPage(page){
        var {items, pageSize} = this.props; 
        //Monina start - added
        items.sort(this.compareMultiples([{field:'dateStamp',order:'desc'}]));
        //Monina end - added       
        var pager = this.state.pager;
        if(page<1 || page > pager.totalPages){
            return;
        }
        pager = this.getPager(items.length, page, pageSize);
        
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
        this.setState({pager: pager});        
        this.onChangePage(pageOfItems);
    }

    getPager(totalItems, currentPage, pageSize){
        currentPage = currentPage || 1;
        pageSize = pageSize || 1;
        var totalPages = Math.ceil(totalItems/pageSize);

        //alert(totalPages);

        var startPage, endPage;


        /*

        if(totalPages <=10){
            startPage = 1;
            endPage = totalPages;
        }else{
            if(currentPage <=6){
                startPage = 1;
                endPage = 10;
            }else if(currentPage + 4 >= totalPages){
                startPage = totalPages - 9;
                endPage = totalPages;
            }else{
                startPage = currentPage - 5;
                endPage = currentPage + 4;                
            }
        }


          */
         startPage = 1;
         endPage = 10; 
  
        var startIndex = (currentPage - 1 ) * pageSize;
        var endIndex = Math.min(startIndex + pageSize -1, totalItems -1);

        //var pages = [...Array((endPage +1) - startPage).keys()].map(i=> startPage +i);


        var pages = 100;

        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex:startIndex,
            endIndex: endIndex,
            pages:pages
        };
    }


    onChangePage(pageOfItems){
        this.setState({pageOfItems: pageOfItems});
    }


    render(){  

        var pager = this.state.pager;

        if(!pager.pages || pager.pages.length <= 1){
          return null;
       }
        return(   
           <div>        
                <AdvisoryHeaderDiv>
                    <AdvisoryHeaderText>Advisory</AdvisoryHeaderText>
                </AdvisoryHeaderDiv>
                <Row as ={Col} noGutters style={{fontSize:'12px', padding:'10px 20px', minHeight:'300px'}}>
                
                    <Col>          
                    
                        {this.state.pageOfItems.map(item =>
                                <Row key={item.advisoryId} noGutters className="col-xs-12 col-sm-12"> 
                                    <Col md={10} xs={12} align="right" >{item.dateStamp.substring(0,10)}</Col> 
                                    <Col md={10} xs={12} align="left" ><br></br>{renderHTML(item.advisory)}</Col>
                                    {/* <Col md={10} xs={12} align="left" ><div width='50px'dangerouslySetInnerHTML={{__html: item.advisory}} /></Col> */}
                                    {/* <Col md={10} xs={12} align="left" >{console.log(item.advisory)} </Col> */}
                                </Row>
                        )}
                
                
                        <Row noGutters style={{paddingTop:'20px'}}>
                            <Col md={5}></Col>
                            <Col md={5}></Col>
                            <Col md={2} as={Row}>                            
                                <Pagination  size='sm'>                    
                                    <Pagination.First align="center"                       
                                    onClick={() => this.setPage(1)}
                                    />
                                    <Pagination.Prev
                                    onClick={() => this.setPage(pager.currentPage - 1)}                        
                                    />                                                           
                                    <Pagination.Next 
                                    onClick={() => this.setPage(pager.currentPage + 1)}
                                    />                                                                                                                                                
                                    <Pagination.Last
                                    onClick = {() => this.setPage(pager.totalPages)}
                                    />
                                </Pagination>     

                                 <div>                    
                            <span className="font-weight-bold">Page {pager.currentPage}</span> / {" "}                            
                            <span className="font-weight-bold">{this.props.items.length}</span>
                        </div>                          
                            </Col>                                                                                                       
                        </Row>
                         
                         
                        </Col>  
                </Row>                                    
            </div>            
            );        
        }
    }


Home.propTypes = propTypes;
Home.defaultProps = defaultProps;
export default Home;